import React from 'react';
import { Paper, Group, Stack, Text, rem } from '@mantine/core';
import { SearchResult, getSearchResultIcon, getEventDescriptionColor } from './utils/searchHelpers';

interface SearchResultItemProps {
  result: SearchResult;
  isMobile: boolean;
  onClick: () => void;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({ result, isMobile, onClick }) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = '#EA580C20';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = '#75757550';
  };

  return (
    <Paper
      p={isMobile ? 'sm' : 'md'}
      radius="md"
      style={{
        backgroundColor: '#75757550',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        maxWidth: '100%',
        boxSizing: 'border-box',
      }}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Group align="flex-start" gap="12px" wrap="nowrap">
        <div style={{ marginTop: rem(2), flexShrink: 0 }}>{getSearchResultIcon(result, 48)}</div>
        <Stack gap="0px" style={{ flex: 1, minWidth: 0 }}>
          <Text size="md" fw={600} c="white" truncate>
            {result.title}
          </Text>
          <Text size="xs" c={result.type === 'upcoming_event' ? '#EA580C' : 'dimmed'} lineClamp={2}>
            {result.type === 'upcoming_event' ? `🟠 ${result.description}` : result.description}
          </Text>
        </Stack>
      </Group>
    </Paper>
  );
};

export default SearchResultItem;
